import http from './public'
// 登陆
export function login(parameter) {
  return axios({
    url: '/mallApi/mall/index/login',
    method: 'post',
    data: parameter
  })
}
// 退出登陆
export function logout(logoutToken) {
  return axios({
    url: '/sys/logout',
    method: 'post',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8',
      'X-Access-Token':  logoutToken
    }
  })
}
// 首页接口
export const productHome = (params) => {
  return http.fetchGet('/goods/productHome', params)
}
// 获取校验码
export function getSmsCode(parameter) {
  return axios({
    url: api.SendSms,
    method: 'post',
    data: parameter
  })
}




// WEBPACK FOOTER //
// ./src/api/index.js